/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_SummaryInputs */

const cs_col_summary = /** @type {(inputs: Col_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shrnutí`)
};

const en_col_summary = /** @type {(inputs: Col_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary`)
};

/**
* | output |
* | --- |
* | "Summary" |
*
* @param {Col_SummaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_summary = /** @type {((inputs?: Col_SummaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_SummaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_summary(inputs)
	return cs_col_summary(inputs)
});